import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgBackFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.296 4.706c.63-.63 1.707-.183 1.707.707V10H20a2 2 0 0 1 .15 3.995L20 14h-8.997v4.585c0 .89-1.077 1.337-1.707.707l-6.588-6.586a1 1 0 0 1 0-1.414l6.588-6.586Z", fill: color }));
};
export default factorySvgIcon(SvgBackFilled);
//# sourceMappingURL=SvgBackFilled.js.map